import { DangerousGoodItem } from '@hazmatsuite-next/ui';
import { EnumPackageType } from './package-type.enum';
import { PackagingModel } from './packaging.model';

export class InnerPackagingModel extends PackagingModel {
  override PackageType = EnumPackageType.InnerPacking;
  IsNetWeightEnabled = false;
  IsNetWeightMandatory = false;
  IsNetVolumeEnabled = false;
  IsNetVolumeMandatory = false;
  IsGrossWeightMandatory = false;
  IsNetExplosiveMassRequired = false;
  IsNetExplosiveMassMandatory = false;
  IsTotalQuantity = false;
  DangerousGoodId?: number;
  NetWeightValue = '';
  NetVolumeValue = '';
  GrossWeightValue = '';
  NetExplosiveMassValue = '';
  LimitPerPackageValue = 0;
  LimitPerPackageCargoAircraftOnlyValue = 0;
  LimitsPerPackageNotExceeded = false;
  IsFlashpointRequired = false;
  IsLithiumBattery = false;
  LithiumBatteryShipmentModeIB = false;
  AlternativePackagingType = '';
  ProperShippingName = '';

  IsEnvironmentallyHazardous = false;
  IsEnvironmentallyHazardousFromDb = false;

  NetWeightUnitSymbol = '';
  NetVolumeUnitSymbol = '';
  GrossWeightUnitSymbol = '';
  NetExplosiveMassUnitSymbol = '';

  DangerousGood?: DangerousGoodItem;
}
